<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="questionnaires">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Cuestionarios&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field hide-details single-line v-model="searchText"></v-text-field>
                        <v-btn small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn text class="text-none" @click="onNewQuestionnaire"
                                >Nuevo Cuestionario</v-btn
                            >
                            <v-btn
                                :disabled="questionnaireID === 0"
                                text
                                class="text-none"
                                @click="onDeleteQuestionnaire"
                                >Borrar Cuestionario</v-btn
                            >

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item @click="onNewQuestionnaire">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1" @click="onNewQuestionnaire"
                                            >mdi-file-plus</v-icon
                                        >&nbsp; Nuevo Cuestionario
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="onDeleteQuestionnaire">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1" @click="onDeleteQuestionnaire"
                                            >mdi-delete</v-icon
                                        >&nbsp; Borrar Cuestionario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red" @click="onClose">mdi-close</v-icon
                                        >&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de cuestionarios y cuestionario seleccionado: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de cuestionarios y card de cuestionario seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de cuestionarios: *************************** -->
                            <v-flex xs10 sm4 md3>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Cuestionarios Registrados</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedQuestionnaireIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(questionnaire, i) in questionnaires"
                                                :key="i"
                                                @click="selectQuestionnaire(questionnaire.id)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{
                                                                    questionnaire.idiomas[0].titulo
                                                                }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Cuestionarios ********************************* -->

                            <!-- Info de Cuestionario seleccionado: *********************** -->
                            <v-flex xs10 sm8 md9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title">{{
                                            selectedQuestionnaireName
                                        }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-clipboard-list-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid grid-list-xl>
                                            <v-layout>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Nombre del Cuestionario
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="
                                                                            onEditQuestionnaireName
                                                                        "
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                            >mdi-pencil</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Editar el nombre del
                                                                    cuestionario</span
                                                                >
                                                            </v-tooltip>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="questionnaireTablesHeader"
                                                                :items="questionnaireNameTable"
                                                                item-key="id"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay nombres para este cuestionario."
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                            ></v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row v-if="bSkills === true">
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Set de Respuestas
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="onChangeAnswerSet"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                            >mdi-pencil</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Cambiar el set de
                                                                    respuestas</span
                                                                >
                                                            </v-tooltip>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-container>
                                                                <v-layout row align-center>
                                                                    <v-flex
                                                                        fill-height
                                                                        xs12
                                                                        sm12
                                                                        md5
                                                                        class="font-weight-regular black--text"
                                                                        >{{
                                                                            labelSetRespuestas
                                                                        }}</v-flex
                                                                    >
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Si el cuestionario no tiene competencias se despliegan sólo las preguntas: -->
                                            <v-layout v-if="bSkills === false" row wrap>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                            >Preguntas</v-card-title
                                                        >

                                                        <v-data-table
                                                            fixed-header
                                                            :headers="questionnaireQuestionHeader"
                                                            :items="questionnaireQuestionTable"
                                                            locale="es-MX"
                                                            hide-default-footer
                                                            no-data-text="No hay preguntas para el cuestionario seleccionado."
                                                            :show-select="false"
                                                            :items-per-page="
                                                                questionnaireQuestionTable.length
                                                            "
                                                        >
                                                            <template v-slot:item.controls="props">
                                                                <v-tooltip bottom>
                                                                    <template
                                                                        v-slot:activator="{ on }"
                                                                    >
                                                                        <v-btn
                                                                            icon
                                                                            @click="
                                                                                onEditQuestion(
                                                                                    props.item
                                                                                )
                                                                            "
                                                                            v-on="on"
                                                                        >
                                                                            <v-icon
                                                                                color="orange accent-4"
                                                                                >mdi-comment-edit</v-icon
                                                                            >
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Editar la pregunta</span>
                                                                </v-tooltip>
                                                            </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Si el cuestionario sí tiene competencias se despliegan las competencias y las preguntas de cada competencia: -->
                                            <v-layout v-else row wrap>
                                                <!-- Lista de Competencias: *************************** -->
                                                <v-flex
                                                    xs12
                                                    v-for="(skill, i) in questionnaireSkills"
                                                    :key="i"
                                                >
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Competencia {{ i + 1 }}
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="
                                                                            onEditQuestionnaireSkill(
                                                                                skill.competenciaid,
                                                                                i + 1
                                                                            )
                                                                        "
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                            >mdi-pencil</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Editar el nombre de la
                                                                    competencia</span
                                                                >
                                                            </v-tooltip>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="questionnaireTablesHeader"
                                                                :items="questionnaireSkillTable[i]"
                                                                item-key="id"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay nombres para esta categoría."
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                            ></v-data-table>
                                                        </v-card-text>

                                                        <v-card-title
                                                            class="teal--text text--darken-3 body-2 font-weight-bold"
                                                            >Preguntas</v-card-title
                                                        >
                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="
                                                                    questionnaireQuestionHeader
                                                                "
                                                                :items="
                                                                    questionnaireQuestionTable[i]
                                                                "
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay preguntas para esta competencia."
                                                                :show-select="false"
                                                                :items-per-page="
                                                                    questionnaireQuestionTable.length
                                                                "
                                                            >
                                                                <template
                                                                    v-slot:item.controls="props"
                                                                >
                                                                    <v-tooltip bottom>
                                                                        <template
                                                                            v-slot:activator="{
                                                                                on
                                                                            }"
                                                                        >
                                                                            <v-btn
                                                                                icon
                                                                                @click="
                                                                                    onEditQuestion(
                                                                                        props.item
                                                                                    )
                                                                                "
                                                                                v-on="on"
                                                                            >
                                                                                <v-icon
                                                                                    color="orange accent-4"
                                                                                    >mdi-comment-edit</v-icon
                                                                                >
                                                                            </v-btn>
                                                                        </template>
                                                                        <span
                                                                            >Editar la
                                                                            pregunta</span
                                                                        >
                                                                    </v-tooltip>
                                                                </template>
                                                            </v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>

                                                <!-- Termina Lista de Competencias ********************************* -->
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Cuestionario seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de Cuestionario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingQuestionnaire" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Cuestionario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el cuestionario
                                        {{ selectedQuestionnaireName }}?
                                    </v-card-title>
                                    <v-card-text class="text-center"
                                        >Esta acción no se puede deshacer.</v-card-text
                                    >
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteQuestionnaireConfirmed"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteQuestionnaire"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Cuestionario *************************** -->

                        <!-- Modal para editar el nombre del cuestionario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditQuestionnaireName"
                                persistent
                                max-width="40%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Nombre del cuestionario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(name, i) in questionnaireNameArray"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="name.languageName"
                                                        type="text"
                                                        required
                                                        v-model="name.name"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmQuestionnaireNameEdition"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelQuestionnaireNameEdition"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar el nombre del cuestionario *************************** -->

                        <!-- Modal para cambiar el set de respuestas general: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgChangeAnswerSet" persistent max-width="45%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Set de respuestas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-check-all</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row align-center>
                                                <v-flex fill-height xs12 sm10 md5>
                                                    <v-radio-group
                                                        dense
                                                        v-model="generalAnswerSet"
                                                        row
                                                        :mandatory="true"
                                                    >
                                                        <v-radio
                                                            label="Por pregunta"
                                                            value="0"
                                                            color="orange accent-4"
                                                            @change="onAnswerSetByQuestion"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="General"
                                                            value="1"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex
                                                    v-if="generalAnswerSet !== '0'"
                                                    fill-height
                                                    xs12
                                                    sm10
                                                    md5
                                                >
                                                    <v-select
                                                        dense
                                                        prepend-icon="mdi-check-all"
                                                        :items="answerSets"
                                                        item-text="nombre"
                                                        item-value="setrespuestasid"
                                                        v-model="questionnaireGeneralAnswerSetID"
                                                        label="Set de respuestas general"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay sets de respuestas registrados"
                                                        @change="onSelectAnswerSet"
                                                        :readonly="generalAnswerSet === '0'"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmChangeAnswerSet"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelChangeAnswerSet"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para cambiar el set de respuestas *************************** -->

                        <!-- Modal para editar el nombre de una competencia: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditSkillName" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Competencia {{ editingSkillNumber }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout v-for="(name, i) in skillNameArray" :key="i">
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="name.languageName"
                                                        type="text"
                                                        required
                                                        v-model="name.name"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSkillEdition"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSkillEdition"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar el nombre de una competencia *************************** -->

                        <!-- Modal para editar una pregunta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditQuestion" persistent max-width="80%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Pregunta {{ editingQuestionNumber }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                row
                                                v-for="(question, i) in questionLangArray"
                                                :key="i"
                                            >
                                                <v-flex v-if="question.longQuestion.length < 31" xs12>
                                                    <v-textarea
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="question.languageName + ' - pregunta extendida'"
                                                        type="text"
                                                        required
                                                        v-model="question.longQuestion"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                        counter
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex v-else xs7>
                                                    <v-textarea
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="question.languageName + ' - pregunta extendida'"
                                                        type="text"
                                                        required
                                                        v-model="question.longQuestion"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                        counter
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex
                                                    xs5
                                                    v-if="question.longQuestion.length > 30"
                                                >
                                                    <v-textarea
                                                        dense
                                                        prepend-icon="mdi-arrow-collapse-horizontal"
                                                        :label="question.languageName +' - pregunta abreviada'"
                                                        type="text"
                                                        required
                                                        v-model="question.shortQuestion"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                        counter
                                                        :rules="[v => (v || '').length <= 30 || 'La pregunta abreviada no debe ser mayor a 30 caracteres']"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row v-if="bSkills === true">
                                                <v-flex xs6>
                                                    <v-select
                                                        dense
                                                        prepend-icon="mdi-check-all"
                                                        :items="answerSets"
                                                        item-text="nombre"
                                                        item-value="setrespuestasid"
                                                        v-model="editingQuestionAnswerSetID"
                                                        label="Set de respuestas"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay sets de respuestas registrados"
                                                        :readonly="questionnaireGeneralAnswerSetID !== 0"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmQuestionEdition"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelQuestionEdition"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar una pregunta *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Búsqueda de Cuestionarios</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-warning</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center"
                                                    >No hay cuestionarios registrados con ese
                                                    nombre.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información Incompleta</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex xs11 class="justify-center">{{
                                                    errorMessage
                                                }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzcan todos los campos *********************************** -->

                        <!-- Modal para cargar archivo de cuestionario nuevo: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bNew" persistent max-width="40%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Nuevo Cuestionario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-cloud-upload</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-file-input
                                                        color="teal darken-3"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        show-size
                                                        label="Cargue un archivo de Excel con el cuestionario a subir..."
                                                        v-model="newQuestionnaireFile"
                                                        >Archivo del Nuevo
                                                        Cuestionario</v-file-input
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onUploadNewQuestionnaireFile"
                                            >OK</v-btn
                                        >

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelUploadNewQuestionnaireFile"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para cargar archivo de cuestionario nuevo *************************** -->

                        <!-- Modal para informar que se debe seleccionar un archivo para el nuevo cuestionario: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bShowNullFileAlert"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Nuevo Cuestionario</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >Debe seleccionar un archivo de MS Excel para el
                                                    nuevo cuestionario.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNullFileAlert = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que se debe seleccionar un archivo para el nuevo cuestionario *********************************** -->

                        <!-- Modal para pedir que se seleccione un set de respuestas: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bSelectAnswerSetWarning"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Set de Respuestas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >Debe seleccionar un set de respuestas general
                                                    para el cuestionario.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bSelectAnswerSetWarning = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se seleccione un set de respuestas *********************************** -->

                        <!-- Modal para informar que no se puede borrar un cuestionario: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bQuestionnaireNotDeleted"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Cuestionario no borrado</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >No es posible borrar el cuestionario seleccionado, ya que está registrado en una encuesta.
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bQuestionnaireNotDeleted = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no se puede borrar un cuestionario *********************************** -->

                        <!-- Modal para informar que hay un error en la edición de una pregunta: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditQuestionError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Error en la edición de la pregunta</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >{{ questionEditError }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgEditQuestionError = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que hay un error en la edición de una pregunta *********************************** -->

                        <!-- Termina renglón único para lista de cuestionarios y cuestionario seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de cuestionarios y cuestionario seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'questionnaires',
    data() {
        return {
            drawer: false,

            bNew: false,
            questionnaireID: 0,
            name: '',
            bSkills: false,
            languageID: 0,
            generalAnswerSet: '0', //'0' = set de respuestas por pregunta, '1' = set de respuestas general.
            tempGeneralAnswerSetID: 0, //Sirve para guardar el generalAnswerSetID original, en caso de que se cancele su selección.
            bInvalidData: false,
            errorMessage: '',

            bDlgEditQuestionnaireName: false,
            bDlgChangeAnswerSet: false,
            bDlgEditSkillName: false,
            editingSkillNumber: 0,
            editingSkillID: 0,
            editingQuestionNumber: 0,
            editingQuestionID: 0,
            editingQuestionAnswerSetID: 0,
            bSelectAnswerSetWarning: false,
            questionnaireNameArray: [], //Arreglo con el nombre del cuestionario en todos los idiomas.
            skillNameArray: [], //Arreglo con el nombre de la competencia seleccionada en todos los idiomas.
            questionLangArray: [], //Arreglo con la pregunta seleccionada en todos los idiomas, para su edición.
            selectedQuestionnaireName: '',
            bDeletingQuestionnaire: false,
            questions: [], //Preguntas del idioma seleccionado.
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            bQuestionnaireNotDeleted: false, //Indica si se debe mostrar el warning que indica que no se pudo borrar un cuestionario.

            selectedQuestion: [], //Indica la pregunta seleccionada de la tabla.
            bDeletingQuestion: false,
            bDlgEditQuestion: false,

            selectedQuestionTxt: '',
            selectedQuestionID: 0,

            noQuestionsText: 'No hay preguntas para el idioma seleccionado.',
            newQuestionnaireFile: null, //Archivo cargado por el file input, para agregar un cuestionario nuevo.
            bShowNullFileAlert: false,

            bDlgEditQuestionError: false,
            questionEditError: '',

            questionsHeader: [
                {
                    text: 'Número',
                    value: 'index',
                    sortable: false,
                    width: '20%',
                    align: 'center',
                    divider: true
                },
                {
                    text: '',
                    value: 'pregunta',
                    sortable: false,
                    width: '60%',
                    divider: true
                }
            ]
        };
    },
    created() {
        this.selectFirstQuestionnaire();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onNewQuestionnaire() {
            this.bNew = true;
        },
        onUploadNewQuestionnaireFile() {
            if (this.newQuestionnaireFile === null) {
                this.bShowNullFileAlert = true;
            } else {
                this.bNew = false;
                console.log('questionnaireFile = ', this.newQuestionnaireFile);
                this.$store.dispatch('uploadNewQuestionnaire', this.newQuestionnaireFile);
            }
        },
        onCancelUploadNewQuestionnaireFile() {
            this.bNew = false;
        },
        onDeleteQuestionnaire() {
            this.bDeletingQuestionnaire = true;
        },
        cancelDeleteQuestionnaire() {
            this.bDeletingQuestionnaire = false;
        },
        deleteQuestionnaireConfirmed() {
            this.bDeletingQuestionnaire = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            // var i;
            // for (i = 0; i < this.questionnaires.length; i++) {
            //     if (this.questionnaires[i].id === this.questionnaireID) {
            //         this.questionnaires.splice(i, 1);
            //         break;
            //     }
            // }

            this.$store.dispatch('deleteQuestionnaire', this.questionnaireID);
            // this.selectFirstQuestionnaire();
        },

        selectFirstQuestionnaire() {
            //console.log('selectFistSet, ', this.questionnaires);
            if (this.questionnaires.length > 0) {
                this.selectedQuestionnaireIndex = 0;
                var questionnaireID = this.questionnaires[this.selectedQuestionnaireIndex].id;
                this.selectQuestionnaire(questionnaireID);
            } else {
                this.selectedQuestionnaireIndex = -1;
                this.questionnaireID = 0;
            }
        },
        selectQuestionnaire(questionnaireID) {
            var i;
            for (i = 0; i < this.questionnaires.length; i++) {
                if (this.questionnaires[i].id === questionnaireID) {
                    this.questionnaireID = questionnaireID;
                    //Se toma como título del cuestionario el del primer idioma registrado:
                    this.selectedQuestionnaireName = this.questionnaires[i].idiomas[0].titulo;
                    if (this.questionnaires[i].competencias === true) {
                        //Cuestionario con competencias...
                        this.bSkills = true;
                        this.noQuestionsText = 'No hay preguntas para la competencia seleccionada.';
                    } //Cuestionario sin competencias...
                    else {
                        this.bSkills = false;
                        this.noQuestionsText = 'No hay preguntas para el idioma seleccionado.';
                    }
                    break;
                }
            }
            console.log('this.bSkills = ', this.bSkills);

            if (this.bSkills) {
                console.log('this.questionnaireSkills = ', this.questionnaireSkills);
                this.$store.dispatch('getSkillQuestionnaireData', questionnaireID);
            } else {
                //this.questionnaireSkills = [];
                console.log('this.questionnaireSkills = ', this.questionnaireSkills);
                this.$store.dispatch('getQuestionnaireData', questionnaireID);
            }
        },

        generateIndexedQuestions(questions) {
            //Se genera el arreglo local con las preguntas del idioma seleccionado, con un índice para saber qué
            //número de pregunta es:

            this.questions = [];

            var i;
            for (i = 0; i < questions.length; i++) {
                const answer = {
                    index: i + 1,
                    id: questions[i].id,
                    pregunta: questions[i].pregunta
                };
                this.questions.push(answer);
            }
        },

        onEditQuestionnaireName() {
            //Se crea un arreglo con el nombre del cuestionario en todos los idiomas configurados:

            this.questionnaireNameArray = [];
            var i;
            for (i = 0; i < this.questionnaireNames.length; i++) {
                var name = {
                    name: this.questionnaireNames[i].nombre,
                    languageID: this.questionnaireNames[i].idiomaid,
                    languageName: ''
                };
                var j;
                for (j = 0; j < this.languages.length; j++) {
                    if (this.questionnaireNames[i].idiomaid === this.languages[j].idiomaid) {
                        name.languageName = this.languages[j].idioma;
                        break;
                    }
                }
                this.questionnaireNameArray.push(name);
            }

            this.bDlgEditQuestionnaireName = true;
        },

        onCancelQuestionnaireNameEdition() {
            this.bDlgEditQuestionnaireName = false;
        },
        onConfirmQuestionnaireNameEdition() {
            //Edita el arreglo de los nombres del cuestionario en los diferentes idiomas:
            var i;
            for (i = 0; i < this.questionnaireNameArray.length; i++) {
                var j;
                for (j = 0; j < this.questionnaireNames.length; j++) {
                    if (
                        this.questionnaireNameArray[i].languageID ===
                        this.questionnaireNames[j].idiomaid
                    ) {
                        this.questionnaireNames[j].nombre = this.questionnaireNameArray[i].name;

                        //Se edita el único renglón que tiene la tabla questionnaireNameTable:
                        const idiomaid = this.questionnaireNameArray[i].languageID;
                        this.questionnaireNameTable[0][idiomaid] = this.questionnaireNameArray[
                            i
                        ].name;
                        break;
                    }
                }
            }

            //Edita el arreglo de la lista de cuestionarios:
            var questionnaireToEdit = null;
            for (i = 0; i < this.questionnaires.length; i++) {
                if (this.questionnaires[i].id === this.questionnaireID) {
                    questionnaireToEdit = this.questionnaires[i];
                    var j;
                    for (j = 0; j < this.questionnaires[i].idiomas.length; j++) {
                        var k;
                        for (k = 0; k < this.questionnaireNames.length; k++) {
                            if (
                                this.questionnaires[i].idiomas[j].idiomaid ===
                                this.questionnaireNames[k].idiomaid
                            ) {
                                this.questionnaires[i].idiomas[j].titulo = this.questionnaireNames[
                                    k
                                ].nombre;
                                break;
                            }
                        }
                    }
                    //Se toma como título del cuestionario el del primer idioma registrado:
                    this.selectedQuestionnaireName = this.questionnaires[i].idiomas[0].titulo;
                    break;
                }
            }

            this.$store.dispatch('updateQuestionnaireNames', questionnaireToEdit);
            this.bDlgEditQuestionnaireName = false;
        },

        onChangeAnswerSet() {
            this.tempGeneralAnswerSetID = this.questionnaireGeneralAnswerSetID;

            if (this.questionnaireGeneralAnswerSetID === 0) {
                //El set de respuestas es por pregunta...
                this.generalAnswerSet = '0';
            } else {
                //questionnaireGeneralAnswerSetID !== 0, o sea, el set de respuestas es general (para todas las preguntas).
                this.generalAnswerSet = '1';
            }
            this.bDlgChangeAnswerSet = true;
            console.log('questionnaireGeneralAnswerSetID = ', this.questionnaireGeneralAnswerSetID);
            console.log('tempGeneralAnswerSetID = ', this.tempGeneralAnswerSetID);
        },

        onCancelChangeAnswerSet() {
            console.log('questionnaireGeneralAnswerSetID = ', this.questionnaireGeneralAnswerSetID);
            console.log('tempGeneralAnswerSetID = ', this.tempGeneralAnswerSetID);
            this.bDlgChangeAnswerSet = false;
            this.questionnaireGeneralAnswerSetID = this.tempGeneralAnswerSetID;

            console.log(
                'Al final, questionnaireGeneralAnswerSetID = ',
                this.questionnaireGeneralAnswerSetID
            );
        },

        onConfirmChangeAnswerSet() {
            console.log('questionnaireGeneralAnswerSetID = ', this.questionnaireGeneralAnswerSetID);

            //Si se escogió tener un set de respuestas general pero no se seleccionó uno, aparece un warning:
            if (this.generalAnswerSet === '1' && this.questionnaireGeneralAnswerSetID === 0) {
                this.bSelectAnswerSetWarning = true;
            } else {
                if (this.generalAnswerSet === '0') {
                    //El set de respuestas es por pregunta...
                    this.questionnaireGeneralAnswerSetID = 0;
                }

                if (this.questionnaireGeneralAnswerSetID !== 0) {
                    //El set de respuestas es el mismo para todas las preguntas....
                    //console.log('this.questionnaireQuestions = ', this.questionnaireQuestions);
                    //console.log('this.questionnaireQuestionTable = ', this.questionnaireQuestionTable);

                    //Busca el nombre del set de respuestas:
                    var answerSetName = '';
                    var x;
                    for (x = 0; x < this.answerSets.length; x++) {
                        if (
                            this.answerSets[x].setrespuestasid ===
                            this.questionnaireGeneralAnswerSetID
                        ) {
                            answerSetName = this.answerSets[x].nombre;
                            break;
                        }
                    }

                    //Se pone el mismo set de respuestas en todas las preguntas:
                    var i;
                    for (i = 0; i < this.questionnaireQuestions.length; i++) {
                        this.questionnaireQuestions[
                            i
                        ].setrespuestasid = this.questionnaireGeneralAnswerSetID;
                    }

                    for (i = 0; i < this.questionnaireQuestionTable.length; i++) {
                        var j;
                        for (j = 0; j < this.questionnaireQuestionTable[i].length; j++) 
{
                            this.questionnaireQuestionTable[i][
                                j
                            ].answerSetID = this.questionnaireGeneralAnswerSetID;
                            this.questionnaireQuestionTable[i][j].answerSet = answerSetName;
                        }
                    }
                }

                //Actualiza setrespuestasid del arreglo questionnaires:
                for (i = 0; i < this.questionnaires.length; i++) {
                    this.questionnaires[i].setrespuestasid = this.questionnaireGeneralAnswerSetID;
                }

                var infoToUpdate = {
                    id: this.questionnaireID,
                    setrespuestasid: this.questionnaireGeneralAnswerSetID
                };

                this.$store.dispatch('updateQuestionnaireAnswerSet', infoToUpdate);
                this.bDlgChangeAnswerSet = false;
            }
            //console.log('generalAnswerSet: ', this.generalAnswerSet);
        },

        onEditQuestionnaireSkill(skillID, skillNumber) 
{
            this.editingSkillID = skillID;
            this.editingSkillNumber = skillNumber;

            //Se crea un arreglo con el nombre de la competencia en todos los idiomas configurados:

            this.skillNameArray = [];

            var i;
            for (i = 0; i < this.questionnaireSkillsLang.length; i++) 
{
                if (this.questionnaireSkillsLang[i].competenciaid === skillID) 
{
                    var name = {
                        name: this.questionnaireSkillsLang[i].competencia,
                        languageID: this.questionnaireSkillsLang[i].idiomaid,
                        languageName: ''
                    };

                    var j;
                    for (j = 0; j < this.languages.length; j++) 
{
                        if (
                            this.questionnaireSkillsLang[i].idiomaid === this.languages[j].idiomaid
                        ) 
{
                            name.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.skillNameArray.push(name);
                }
            }

            this.bDlgEditSkillName = true;
        },

        onCancelSkillEdition() {
            this.bDlgEditSkillName = false;
        },

        onConfirmSkillEdition() {
            //Edita el arreglo de los nombres de la competencia en los diferentes idiomas:

            //console.log('skillNameArray = ', this.skillNameArray);
            //console.log('questionnaireSkillsLang = ', this.questionnaireSkillsLang);
            //console.log('editingSkillID = ', this.editingSkillID);
            //console.log('questionnaireSkillTable = ', this.questionnaireSkillTable);
            //console.log('questionnaireSkillTable[0][0] = ', this.questionnaireSkillTable[0][0][1]);

            var i;
            for (i = 0; i < this.skillNameArray.length; i++) 
{
                var j;
                for (j = 0; j < this.questionnaireSkillsLang.length; j++) 
{
                    if (
                        this.questionnaireSkillsLang[j].competenciaid === this.editingSkillID &&
                        this.skillNameArray[i].languageID ===
                            this.questionnaireSkillsLang[j].idiomaid
                    ) 
{
                        this.questionnaireSkillsLang[j].competencia = this.skillNameArray[i].name;

                        //Se edita tabla questionnaireSkillTable, en el elemento 0 del renglón que contiene la competencia editada:
                        var k;
                        for (k = 0; k < this.questionnaireSkillTable.length; k++) 
{
                            if (this.questionnaireSkillTable[k][0].id === this.editingSkillID) 
{
                                const idiomaid = this.skillNameArray[i].languageID;
                                this.questionnaireSkillTable[k][0][idiomaid] = this.skillNameArray[
                                    i
                                ].name;
                                break;
                            }
                        }
                    }
                }
            }

            //console.log('questionnaires = ', this.questionnaires);
            this.$store.dispatch('updateQuestionnaireSkills');

            this.bDlgEditSkillName = false;
        },

        onEditQuestion(item)
        {
            //console.log('questionnaireQuestionsLang = ', this.questionnaireQuestionsLang);

            this.editingQuestionID = item.questionID;
            this.editingQuestionNumber = item.num;

            //Si el cuestionario tiene competencias, se obtiene el set de respuestas de la pregunta:
            if (this.bSkills)
            {
                this.editingQuestionAnswerSetID = item.answerSetID;
            }

            //Se crea un arreglo con la pregunta en todos los idiomas configurados:

            this.questionLangArray = [];

            var i;
            for (i = 0; i < this.questionnaireQuestionsLang.length; i++)
            {
                if (this.questionnaireQuestionsLang[i].preguntaid === item.questionID)
                {
                    var question = {
                        longQuestion: this.questionnaireQuestionsLang[i].pregunta,
                        shortQuestion: this.questionnaireQuestionsLang[i].alias,
                        languageID: this.questionnaireQuestionsLang[i].idiomaid,
                        languageName: ''
                    };

                    var j;
                    for (j = 0; j < this.languages.length; j++)
                    {
                        if (this.questionnaireQuestionsLang[i].idiomaid === this.languages[j].idiomaid)
                        {
                            question.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.questionLangArray.push(question);
                }
            }

            //console.log('questionLangArray = ', this.questionLangArray);
            this.bDlgEditQuestion = true;
        },

        onConfirmQuestionEdition() 
        {
            //console.log('questionnaireQuestionTable = ', this.questionnaireQuestionTable);

            //Checa las longitudes de las respuestas extendidas y abreviadas:
            var i;
            var bQuestionsLongOK = true; //Indica si hay algún error en alguna longitud de las respuestas.

            for (i = 0; i < this.questionLangArray.length; i++)
            {
                if (this.questionLangArray[i].longQuestion.length > 30)
                {
                    if ((this.questionLangArray[i].shortQuestion == null) || (this.questionLangArray[i].shortQuestion.length === 0))
                    {
                        this.questionEditError = 'Por favor introduzca la pregunta abreviada faltante.';
                        bQuestionsLongOK = false;
                        break;
                    }
                    else
                    {
                        if (this.questionLangArray[i].shortQuestion.length > 30)
                        {
                            this.questionEditError = 'Las preguntas abreviadas no deben tener más de 30 caracteres.';
                            bQuestionsLongOK = false;
                            break;
                        }
                    }
                }
                else
                {
                    this.questionLangArray[i].shortQuestion = "";
                }
            }
            if (bQuestionsLongOK)
            {
                //Arreglo con las preguntas en todos los idiomas que se mandará al servidor:
                var questionsLangToEdit = [];

                //Edita el arreglo de los nombres de la pregunta en los diferentes idiomas:
                for (i = 0; i < this.questionLangArray.length; i++)
                {
                    var j;
                    for (j = 0; j < this.questionnaireQuestionsLang.length; j++)
                    {
                        if (this.questionnaireQuestionsLang[j].preguntaid === this.editingQuestionID &&
                            this.questionLangArray[i].languageID === this.questionnaireQuestionsLang[j].idiomaid)
                        {
                            this.questionnaireQuestionsLang[j].pregunta = this.questionLangArray[i].longQuestion;
                            this.questionnaireQuestionsLang[j].alias = this.questionLangArray[i].shortQuestion;

                            const questionLangToEdit = {
                                preguntaid: this.questionnaireQuestionsLang[j].preguntaid,
                                idiomaid: this.questionnaireQuestionsLang[j].idiomaid,
                                pregunta: this.questionnaireQuestionsLang[j].pregunta,
                                alias: this.questionnaireQuestionsLang[j].alias
                            };

                            questionsLangToEdit.push(questionLangToEdit);

                            //Se edita la tabla questionnaireQuestionTable:
                            var k;

                            //Si el cuestionario tiene competencias, el arreglo questionnaireQuestionTable tiene dimensiones de
                            //núm. de competencias (k) x núm. de preguntas por competencia (l), por lo que cada competencia k
                            //se recorre l veces para buscar la pregunta a editar:
                            if (this.bSkills)
                            {
                                for (k = 0; k < this.questionnaireQuestionTable.length; k++)
                                {
                                    var l;
                                    for (l = 0; l < this.questionnaireQuestionTable[k].length; l++)
                                    {
                                        if (this.questionnaireQuestionTable[k][l].questionID === this.editingQuestionID)
                                        {
                                            const idiomaid = this.questionLangArray[i].languageID;
                                            this.questionnaireQuestionTable[k][l][idiomaid] = this.questionLangArray[i].longQuestion;
                                            this.questionnaireQuestionTable[k][l].answerSetID = this.editingQuestionAnswerSetID;

                                            //Obtiene el nombre del set de respuestas:
                                            var m;
                                            for (m = 0; m < this.answerSets.length; m++)
                                            {
                                                if (this.answerSets[m].setrespuestasid === this.editingQuestionAnswerSetID)
                                                {
                                                    this.questionnaireQuestionTable[k][l].answerSet = this.answerSets[m].nombre;
                                                    break;
                                                }
                                            }

                                            break;
                                        }
                                    }
                                }
                            }
                            //Si el cuestionario no tiene competencias, el arreglo questionnaireQuestionTable tiene dimensiones de
                            //núm. preguntas (k):
                            else
                            {
                                for (k = 0; k < this.questionnaireQuestionTable.length; k++)
                                {
                                    if (this.questionnaireQuestionTable[k].questionID === this.editingQuestionID)
                                    {
                                        const idiomaid = this.questionLangArray[i].languageID;
                                        this.questionnaireQuestionTable[k][idiomaid] = this.questionLangArray[i].longQuestion;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                //console.log('questionnaireQuestionsLang: ', this.questionnaireQuestionsLang);

                const questionToEdit = {
                    preguntas: {
                        preguntaid: this.editingQuestionID,
                        competenciaid: 0,
                        setrespuestasid: this.editingQuestionAnswerSetID,
                        tipoconceptoid: 0
                    },
                    preguntasIdiomas: questionsLangToEdit
                };

                //console.log('questionToEdit = ', questionToEdit);

                this.$store.dispatch('updateQuestionnaireQuestion', questionToEdit);

                this.bDlgEditQuestion = false;
            } //if (bQuestionsLongOK === false)
            else
            {
                this.bDlgEditQuestionError = true;
            }
        },

        onCancelQuestionEdition()
        {
            this.bDlgEditQuestion = false;
        },

        onAnswerSetByQuestion()
        {
            this.questionnaireGeneralAnswerSetID = 0;
        },

        onSelectAnswerSet()
        {
            // console.log('generalAnswerSet = ', this.generalAnswerSet);
            // if (this.generalAnswerSet === '0') {
            //     this.questionnaireGeneralAnswerSetID = 0;
            // }
        },

        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.questionnaires.length; i++)
                {
                    var strLowerCaseText = this.questionnaires[i].idiomas[0].titulo.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedQuestionnaireIndex = i;
                        this.selectQuestionnaire(this.questionnaires[i].id);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        }
    },
    computed: {
        ...mapGetters([
            'questionnaires',
            'waitCursor',
            'languages',
            'questionnaireNames',
            'questionnaireNameTable',
            'questionnaireTablesHeader',
            'questionnaireQuestionHeader',
            'questionnaireSkills',
            'answerSets',
            'questionnaireSkillTable',
            'questionnaireQuestions'
        ]),
        selectedQuestionnaireIndex: {
            get() {
                return this.$store.getters.selectedQuestionnaireIndex;
            },
            set(selectedQuestionnaireIndex) {
                this.$store.dispatch(
                    'updateSelectedQuestionnaireIndex',
                    selectedQuestionnaireIndex
                );
            }
        },
        searchNewQuestionnaire: {
            get() {
                return this.$store.getters.searchNewQuestionnaire;
            },
            set(searchNewQuestionnaire) {
                this.$store.dispatch('updateSearchNewQuestionnaire', searchNewQuestionnaire);
            }
        },
        newQuestionnaireID: {
            get() {
                return this.$store.getters.newQuestionnaireID;
            },
            set(newQuestionnaireID) {
                this.$store.dispatch('updateNewQuestionnaireID', newQuestionnaireID);
            }
        },
        questionnaireGeneralAnswerSetID: {
            get() {
                return this.$store.getters.questionnaireGeneralAnswerSetID;
            },
            set(questionnaireGeneralAnswerSetID) {
                this.$store.dispatch(
                    'updateQuestionnaireGeneralAnswerSetID',
                    questionnaireGeneralAnswerSetID
                );
            }
        },
        enableAnswerSet() {
            var enableChooseSet;
            //if (this.questionnaireGeneralAnswerSetID === 0) {
            if (this.generalAnswerSet === '1') {
                enableChooseSet = true;
            } else {
                enableChooseSet = false;
            }
            return generalSet;
        },
        labelSetRespuestas() {
            var strLabel;
            if (this.questionnaireGeneralAnswerSetID === 0) {
                strLabel = 'Set de respuestas por pregunta';
            } else {
                var i;
                for (i = 0; i < this.answerSets.length; i++) {
                    if (
                        this.questionnaireGeneralAnswerSetID === this.answerSets[i].setrespuestasid
                    ) {
                        strLabel = this.answerSets[i].nombre;
                        break;
                    }
                }
            }
            return strLabel;
        },
        // questionnaireSkills: {
        //     get() {
        //         return this.$store.getters.questionnaireSkills;
        //     },
        //     set(questionnaireSkills) {
        //         this.$store.dispatch('updateQuestionnaireSkills', questionnaireSkills);
        //     }
        // },
        questionnaireSkillsLang: {
            get() {
                return this.$store.getters.questionnaireSkillsLang;
            },
            set(questionnaireSkillsLang) {
                this.$store.dispatch('updateQuestionnaireSkillsLang', questionnaireSkillsLang);
            }
        },
        questionnaireQuestions: {
            get() {
                return this.$store.getters.questionnaireQuestions;
            },
            set(questionnaireQuestions) {
                this.$store.dispatch('updateQuestionnaireQuestions', questionnaireQuestions);
            }
        },
        questionnaireQuestionsLang: {
            get() {
                return this.$store.getters.questionnaireQuestionsLang;
            },
            set(questionnaireQuestionsLang) {
                this.$store.dispatch(
                    'updateQuestionnaireQuestionsLang',
                    questionnaireQuestionsLang
                );
            }
        },
        questionnaireQuestionTable: {
            get() {
                return this.$store.getters.questionnaireQuestionTable;
            },
            set(questionnaireQuestionTable) {
                this.$store.dispatch(
                    'updateQuestionnaireQuestionTable',
                    questionnaireQuestionTable
                );
            }
        },
        questionnaireNotDeletedWarning: {
            get() {
                return this.$store.getters.questionnaireNotDeletedWarning;
            },
            set(questionnaireNotDeletedWarning) {
                this.$store.dispatch(
                    'updateQuestionnaireNotDeletedWarning',
                    questionnaireNotDeletedWarning
                );
            }
        },

        serverResponse: {
            get() {
                return this.$store.getters.serverResponse;
            },
            set(serverResponse) {
                this.$store.dispatch('updateServerResponse', serverResponse);
            }
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '550px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        }
    },
    watch: {
        searchNewQuestionnaire: function(value, oldValue) {
            console.log('SearchNewQuestionnaire old value: ', oldValue);
            console.log('SearchNewQuestionnaire new value: ', value);

            if (this.newQuestionnaireID !== 0) {
                this.selectQuestionnaire(this.newQuestionnaireID);
                this.searchNewQuestionnaire = false;
                this.newQuestionnaireID = 0;
            }
        },
        serverResponse: function(value, oldValue) {
            if (this.serverResponse) {
                if (this.questionnaireNotDeletedWarning) {
                    this.bQuestionnaireNotDeleted = true;
                    this.questionnaireNotDeletedWarning = false;
                } else {
                    //El cuestionario se pudo borrar.
                    //Primero se borra el cuestionario de la lista questionnaires, la cual es local:
                    var i;
                    for (i = 0; i < this.questionnaires.length; i++) {
                        if (this.questionnaires[i].id === this.questionnaireID) {
                            this.questionnaires.splice(i, 1);
                            break;
                        }
                    }
                    this.selectFirstQuestionnaire();
                }
            }

            this.serverResponse = false;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.questionnaires {
    /* background: url('../assets/christina-wocintechchat-com-faEfWCdOKIg-unsplash.jpg'); */
    background: url('../assets/mainbackground.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
